<template>
  <div class="data-page">
     <Tabs type="card">
      <TabPane class="data-pane" :label="$t('data.Order.Order_report')">
        <Form class="edit-form" :label-width="100" inline>
          <FormItem :label="$t('data.Order.orderNo')">
            <Select class="info collectorSelect" v-model="orderID" :value="orderID" filterable>
              <Option :value="Number(0)" :key="Number(0)">{{$t('data.Order.please_enter')}}</Option>
              <Option v-for="item in orderList" :value="item.orderID" :key="item.orderID">{{ item.orderNo }}</Option>
            </Select>
          </FormItem>
          <FormItem :label="$t('data.Order.status')">
            <Select class="info collectorSelect" v-model="Valid" :value="Valid">
              <!-- <Option value="1" key= 1>{{$t('data.Order.No_scheduling')}}</Option>
              <Option value="2" key= 2>{{$t('data.Order.Not_production')}}</Option> -->
              <Option value="3" key= 3>{{$t('data.Order.Producting')}}</Option>
              <Option value="4" key= 4>{{$t('data.Order.Case_closed')}}</Option>
            </Select>
          </FormItem>
          <FormItem :label="$t('data.Order.start_date')">
            <DatePicker @on-change="entryTimeChange1" :value="selectTime1" :placeholder="$t('data.Order.please_enter_date')"></DatePicker>
          </FormItem>
          <FormItem :label="$t('data.Order.end_date')">
            <DatePicker @on-change="entryTimeChange2" :value="selectTime2" :placeholder="$t('data.Order.please_enter_date')"></DatePicker>
          </FormItem>
          <Button type="primary" @click="getData(1)">{{$t('data.Order.ok')}}</Button>
          <Button type="primary" @click="exportData(1)"><Icon type="ios-download-outline"></Icon>{{$t('data.Order.out')}}</Button>
        </Form>
        <Table class="device-data-table" highlight-row stripe border :columns="deviceColumns1" :data="orderDatas1" :loading="loading" ref="table"></Table>
      </TabPane>
      <TabPane class="data-pane" :label="$t('data.Order.history')">
        <Form class="edit-form" :label-width="100" inline>
          <FormItem :label="$t('data.Order.orderNo')">
            <Select class="info collectorSelect" v-model="orderID" :value="orderID" filterable>
              <Option :value="Number(0)" :key="Number(0)">{{$t('data.Order.please_enter')}}</Option>
              <Option v-for="item in orderList" :value="item.orderID" :key="item.orderID">{{ item.orderNo }}</Option>
            </Select>
          </FormItem>
          <FormItem :label="$t('data.Order.start_date')">
            <DatePicker @on-change="entryTimeChange3" :value="selectTime3" :placeholder="$t('data.Order.please_enter_date')"></DatePicker>
          </FormItem>
          <FormItem :label="$t('data.Order.end_date')">
            <DatePicker @on-change="entryTimeChange4" :value="selectTime4" :placeholder="$t('data.Order.please_enter_date')"></DatePicker>
          </FormItem>
          <FormItem :label="$t('data.Order.time_range')">
            <TimePicker format="HH:mm" @on-change="entryTimeChange5" :value="startTime" ></TimePicker>
            -
            <TimePicker format="HH:mm" @on-change="entryTimeChange6" :value="endTime"></TimePicker>
          </FormItem>
          <Button type="primary" @click="getData(2)">{{$t('data.Order.ok')}}</Button>
          <Button type="primary" @click="exportData(2)"><Icon type="ios-download-outline"></Icon>{{$t('data.Order.out')}}</Button>
        </Form>
        <Table class="device-data-table" highlight-row stripe border :columns="deviceColumns2" :data="orderDatas2" :loading="loading" ref="table1"></Table>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import {Api} from '@/api'

export default {
  name: 'Plan',
  data () {
    return {
      orderID: 0,
      Valid: '',
      selectTime1: '',
      selectTime2: '',
      selectTime3: '',
      selectTime4: '',
      startTime: '',
      endTime: '',
      deviceColumns1: [
        { title: this.$t('data.Order.orderNo'), key: 'orderNo' },
        { title: this.$t('data.Order.productNo'), key: 'productNo' },
        { title: this.$t('data.Order.collectorName'), key: 'collectorName' },
        { title: this.$t('data.Order.status'), key: 'status' },
        { title: this.$t('data.Order.salesman'), key: 'salesman' },
        { title: this.$t('data.Order.customer'), key: 'customer' },
        { title: this.$t('data.Order.ordersTime'), key: 'ordersTime' },
        { title: this.$t('data.Order.productTime'), key: 'productTime' },
        { title: this.$t('data.Order.num'), key: 'num' },
        { title: this.$t('data.Order.output'), key: 'output' },
        { title: this.$t('data.Order.target'), key: 'target' },
        { title: this.$t('data.Order.unit'), key: 'unit' },
        { title: this.$t('data.Order.deliveryTime'), key: 'deliveryTime' }
      ],
      deviceColumns2: [
        { title: this.$t('data.Order.orderNo'), key: 'orderNo' },
        { title: this.$t('data.Order.productNo'), key: 'productNo' },
        { title: this.$t('data.Order.collectorName'), key: 'collectorName' },
        { title: this.$t('data.Device.date'), key: 'date' },
        // { title: this.$t('data.Order.salesman'), key: 'salesman' },
        // { title: this.$t('data.Order.customer'), key: 'customer' },
        // { title: this.$t('data.Order.ordersTime'), key: 'ordersTime' },
        // { title: this.$t('data.Order.productTime'), key: 'productTime' },
        // { title: this.$t('data.Order.num'), key: 'num' },
        { title: this.$t('data.Order.output'), key: 'output' },
        // { title: this.$t('data.Order.target'), key: 'target' },
        { title: this.$t('data.Order.unit'), key: 'unit' }
        // { title: this.$t('data.Order.deliveryTime'), key: 'deliveryTime' }
      ],
      orderList: [],
      orderDatas1: [],
      orderDatas2: [],
      worktime: '',
      loading: false
    }
  },
  methods: {
    getData (tp) {
      this.loading = true
      if (tp === 1) {
        let time1 = this.selectTime1
        let time2 = this.selectTime2
        if (time1 === '' || time2 === '') {
          const title = this.$t('Order.error')
          const content = this.$t('data.Device.please_enter_date')
          this.$Modal.error({
            title: title,
            content: content
          })
          return
        }
        if (this.selectTime1 !== '' && this.selectTime2 !== '') {
          this.selectTime2 = new Date(new Date(this.selectTime2).getTime() + 1 * 24 * 60 * 60 * 1000)
          this.selectTime2 = this.selectTime2.getFullYear() + '-' + (this.selectTime2.getMonth() + 1) + '-' + this.selectTime2.getDate()
          this.selectTime1 = this.selectTime1 + ' ' + this.worktime
          this.selectTime2 = this.selectTime2 + ' ' + this.worktime
        }
        let req = {orderID: this.orderID, startTime: this.selectTime1, endTime: this.selectTime2}
        this.selectTime1 = time1
        this.selectTime2 = time2
        Api.data.orderData(req).then(res => {
          this.loading = false
          this.orderDatas1 = res.datas
          let d = []
          let j = 0
          for (let i = 0; i < this.orderDatas1.length; i++) {
            this.orderDatas1[i].target = (this.orderDatas1[i].num / this.orderDatas1[i].SumRow * this.orderDatas1[i].row).toFixed(2)
            if (this.orderDatas1[i].unit === 1) {
              this.orderDatas1[i].unit = this.$t('data.Order.Meter')
            } else if (this.orderDatas1[i].unit === 2) {
              this.orderDatas1[i].unit = this.$t('data.Order.Yard')
              this.orderDatas1[i].output = this.orderDatas1[i].output * 1.0936
              this.orderDatas1[i].output = this.orderDatas1[i].output.toFixed(0)
            } else if (this.orderDatas1[i].unit === 3) {
              this.orderDatas1[i].unit = this.$t('data.Order.Gross')
              this.orderDatas1[i].output = this.orderDatas1[i].output / (144.0 * 0.9144)
              this.orderDatas1[i].output = this.orderDatas1[i].output.toFixed(0)
            }
            if (this.orderDatas1[i].collectorName === '') {
              this.orderDatas1[i].status = this.$t('data.Order.No_scheduling')
            } else if (this.orderDatas1[i].collectorName !== '' && this.orderDatas1[i].productTime === '') {
              this.orderDatas1[i].status = this.$t('data.Order.Not_production')
            } else if (this.orderDatas1[i].productTime !== '' && this.orderDatas1[i].valid === 1) {
              this.orderDatas1[i].status = this.$t('data.Order.Producting')
            } else if (this.orderDatas1[i].productTime !== '' && this.orderDatas1[i].valid === 0) {
              this.orderDatas1[i].status = this.$t('data.Order.Case_closed')
            }
            if (this.Valid === '1') {
              if (this.orderDatas1[i].collectorName === '') {
                this.orderDatas1[i].status = this.$t('data.Order.No_scheduling')
                d[j] = this.orderDatas1[i]
                j++
              }
            } else if (this.Valid === '2') {
              if (this.orderDatas1[i].collectorName !== '' && this.orderDatas1[i].productTime === '') {
                this.orderDatas1[i].status = this.$t('data.Order.Not_production')
                d[j] = this.orderDatas1[i]
                j++
              }
            } else if (this.Valid === '3') {
              if (this.orderDatas1[i].productTime !== '' && this.orderDatas1[i].valid === 1) {
                this.orderDatas1[i].status = this.$t('data.Order.Producting')
                d[j] = this.orderDatas1[i]
                j++
              }
            } else if (this.Valid === '4') {
              if (this.orderDatas1[i].productTime !== '' && this.orderDatas1[i].valid === 0) {
                this.orderDatas1[i].status = this.$t('data.Order.Case_closed')
                d[j] = this.orderDatas1[i]
                j++
              }
            }
          }
          if (this.Valid === '1' || this.Valid === '2' || this.Valid === '3' || this.Valid === '4') {
            this.orderDatas1 = d
          }
        })
      } else {
        let req = {orderID: this.orderID, startTime: this.startTime + ':00', endTime: this.endTime + ':00', startDate: this.selectTime3, endDate: this.selectTime4}
        Api.data.orderDayData(req).then(res => {
          this.loading = false
          this.orderDatas2 = res.datas
          for (let i = 0; i < this.orderDatas2.length; i++) {
            if (this.orderDatas2[i].unit === 1) {
              this.orderDatas2[i].unit = this.$t('data.Order.Meter')
              this.orderDatas2[i].output = this.orderDatas2[i].output.toFixed(2)
            } else if (this.orderDatas2[i].unit === 2) {
              this.orderDatas2[i].unit = this.$t('data.Order.Yard')
              this.orderDatas2[i].output = this.orderDatas2[i].output * 1.0936
              this.orderDatas2[i].output = this.orderDatas2[i].output.toFixed(2)
            } else if (this.orderDatas2[i].unit === 3) {
              this.orderDatas2[i].unit = this.$t('data.Order.Gross')
              this.orderDatas2[i].output = this.orderDatas2[i].output / (144.0 * 0.9144)
              this.orderDatas2[i].output = this.orderDatas2[i].output.toFixed(2)
            }
          }
        })
      }
    },
    // dateChange (t) {
    //   this.selectTime = t
    // },
    exportData (tp) {
      if (tp === 1) {
        this.$refs.table.exportCsv({
          filename: this.$t('data.Order.Order_report'),
          original: false
        })
      } else {
        this.$refs.table1.exportCsv({
          filename: this.$t('data.Order.Order_report'),
          original: false
        })
      }
    },
    entryTimeChange1 (v) {
      this.selectTime1 = v
    },
    entryTimeChange2 (v) {
      this.selectTime2 = v
    },
    entryTimeChange3 (v) {
      this.selectTime3 = v
    },
    entryTimeChange4 (v) {
      this.selectTime4 = v
    },
    entryTimeChange5 (v) {
      this.startTime = v
    },
    entryTimeChange6 (v) {
      this.endTime = v
    }
  },
  mounted () {
    Api.order.list().then(res => {
      this.orderList = res.orderInfos
    })
    Api.workTime.list().then(res => {
      this.worktime = res.workTimes[0].startTime
      // console.log(this.worktime)
    })
  },
  beforeRouteEnter (to, from, next) {
    next()
  }
}
</script>
<style>
.data-page {
  padding: 10px;
  height: 100%;
}
.plan-header>div,.plan-body>div {
  border: #ccc 1px solid;
  padding: 10px;
}
.plan-row .ivu-col {
  padding: 0 10px;
}
.data-pane {
  min-height: 500px;
}
.daterange {
  width: 200px;
}
</style>





// WEBPACK FOOTER //
// order.vue?0c17fd06